import styled from 'styled-components';

export const HistogramContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .recharts-responsive-container {
    flex-grow: 1;
    flex-shrink: 1;
  }

  .recharts-wrapper {
    .recharts-cartesian-axis {
      font-size: 12px;
    }

    .recharts-cartesian-grid-horizontal {
      line:first-of-type,
      line:last-of-type {
        stroke-opacity: 0;
      }
    }
  }
`;
